import { AnimatePresence, motion } from "framer-motion"
import { LogIn, X } from "lucide-react"
import { useEffect, useRef } from "react"
import { NavLink } from "react-router-dom"
import { toggleProps } from "../../interface/interfaces"
import './userentry.scss'

const UserEntry=({toggle,setToggle}:toggleProps)=>{

 const authBox = useRef<HTMLDivElement>(null)

     useEffect(() => {
            const handleClickOutside = (event: MouseEvent) => {
                if (
                    toggle &&
                    authBox.current &&
                    !authBox.current.contains(event.target as Node)) {
    
                    setToggle(false)
                }
            }
    
    
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
            
        // eslint-disable-next-line
        }, [toggle]);


    return ( 
    <AnimatePresence>
        {toggle && (
            <motion.div className='userEntryPrompt'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >

                <motion.div className="auth-modal"
                    initial={{ scale: 0.8, opacity: 0, }}
                    animate={{ scale: 1, opacity: 1, }}
                    exit={{ scale: 0.9, opacity: 0, }}
                    transition={{ type: "spring", stiffness: 500, damping: 20 }}

                    ref={authBox}
                >

                    <div>

                        <button className="close-button" onClick={()=>setToggle((prev)=> !prev)} >
                            <X size={20}></X>
                        </button>


                        <div className='icon_enter'><LogIn size={35}></LogIn></div>

                        <div className='title'>You're not signed in</div>
                        <div className='text'>To continue, please sign in or create an account.</div>
                        <div className="button-group">
                            <NavLink to={'/signin'}><div className="btn sign-in">Sign In</div></NavLink>
                            <NavLink to={'/signup'}><div className='crt_acc'>Create an account</div></NavLink>
                        </div>

                    </div>

                </motion.div>

            </motion.div>
        )}

    </AnimatePresence>
    )
}


export default UserEntry